import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'aws-amplify/utils';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import DialogConfirmRemove from '../../Components/DialogConfirmRemove/DialogConfirmRemove';
import InstallationManager from "../../Components/AdministrationManagers/InstallationManager";
import AccountManager from "../../Components/AdministrationManagers/AccountManager";
import UserManager from "../../Components/AdministrationManagers/UserManager";
import GraphQlTool from "../../../Utils/GraphQlTool";
import {getDetailedAccounts} from "../../../graphql/queries";
import '../Settings/Settings.css';
import './Administration.css';
import GroupManager from "../../Components/AdministrationManagers/GroupManager";
import DialogDisplayGroups from "../../Components/AdministrationManagers/DialogDisplayGroups";
import DialogUserData from "../../Components/AdministrationManagers/DialogUserData";
import {AccountType, UserType} from "../../../Models/Enums";
import { Roles } from '../../../Models/Roles.js';

let adminInstance;
let loadedUsers = [];

function TabPanel( props ) {
	const { children, value, index, ...other } = props;

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}


			{...other}
		>
			{value === index && <div>{children}</div>}
		</Typography>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

/**
 * Vue d'administration : regroupe la gestion des utilisateurs, installations,
 * comptes et groupes selon le type de compte connecté.
 * @typedef {Object} AdministrationProps
 * @property {{currentUser: {accountId: number, accountType: number, type: number, role: number, id: number, uuid: string}}} observer Tableau de bord et utilisateur courant.
 * @property {import('../../../Models/DomainTypes').PayStation[]} payStations
 * @property {import('../../../Models/DomainTypes').PayStation[]} filteredPayStations
 * @property {{graphql: (operation: object) => Promise<any>}} API
 * @property {string} locale
 * @property {boolean} isDarkStyle
 * @property {boolean} isDesktop
 * @property {import('../../../Models/DomainTypes').EntityId | null} [removedBoxId]
 * @property {(boxId: import('../../../Models/DomainTypes').EntityId) => void} onPaystationRemoved
 * @property {(boxId: import('../../../Models/DomainTypes').EntityId) => void} onRequestedBoxOverview
 * @property {(boxId: import('../../../Models/DomainTypes').EntityId, deviceId: import('../../../Models/DomainTypes').EntityId) => void} onRequestedBoxDiagnostic
 * @property {import('../../../Utils/UserDataManager').default} [user] Ancienne prop non transmise par Dashboard.
 * @property {object} [registeredNodes] Ancienne prop non transmise par Dashboard.
 */

/** @extends {React.Component<AdministrationProps>} */
class Administration extends React.Component {
	constructor( props ) {
		super( props );
		const tab = ( props.removedBoxId && props.removedBoxId > 0 ) ? 1 : 0;
		this.state = {
			rows: [],
			value: tab,
			pendingDelete:null,
			pendingEdit:null,
			currentFilterRole:0,
			currentFilterField:null,
			isLoading: true,
			userGroups: null,
			accounts: null
		};

		adminInstance = this;
	};

	loadAccounts() {
		if( this.props.API ) {
			this.props.API
				.graphql({ query: getDetailedAccounts, variables: { accountId: this.props.observer.currentUser.accountId }})
				.then( returned => {
					const tool = new GraphQlTool( 'getDetailedAccounts' , returned );
					this.setState( { accounts: tool.extract() } );

				})
				.catch((error) => {
					console.error("error" , error);
				})
		}
	};

	handleChange(event, newValue) {
		if( adminInstance.state.pendingDelete ) {
			adminInstance.state.pendingDelete.usertype = newValue;
		}
		
		if( adminInstance.state.pendingEdit ) {
			adminInstance.state.pendingEdit.usertype = newValue;
		}
		
        adminInstance.setState({
			rows:adminInstance.state.rows,
			value:newValue,
			pendingDelete:adminInstance.state.pendingDelete,
			pendingEdit:adminInstance.state.pendingEdit,
			currentFilterRole:adminInstance.state.currentFilterRole,
			currentFilterField:adminInstance.state.currentFilterField,
		});
    };

	displayGroupsHandler( groups ) {
		adminInstance.setState({
			value:adminInstance.state.value,
			pendingDelete:adminInstance.state.pendingDelete,
			pendingEdit:adminInstance.state.pendingEdit,
			currentFilterRole:adminInstance.state.currentFilterRole,
			currentFilterField:adminInstance.state.currentFilterField,
			userGroups:groups
		});
	};

	handleClearUserGroups( groups ) {
		adminInstance.setState({
			value:adminInstance.state.value,
			pendingDelete:adminInstance.state.pendingDelete,
			pendingEdit:adminInstance.state.pendingEdit,
			currentFilterRole:adminInstance.state.currentFilterRole,
			currentFilterField:adminInstance.state.currentFilterField,
			userGroups:null
		});
	};
	
	filterRegistered( rows ) {
		/*if( this.props.registeredNodes ) {
			let filtered = [];
			rows.map( (candidate) => {
				if( Object.keys( this.props.registeredNodes ).includes( `${candidate["node_id"]}` ) ) {
					filtered.push( candidate );
				}
				return true;
			} );
			return filtered;
		}*/
		return rows;
	}
	
	filterByRoles( rows ) {
		if( adminInstance.state.currentFilterRole !== 0 ) {
			if( rows ) {
				let filtered = [];
				rows.forEach( (candidate) => {
					if( candidate.usertype === adminInstance.state.currentFilterRole ) {
						filtered.push( candidate );
					}
				} );
				return filtered;
			}
			
		}
		return rows;
	}
	
	filterByName( rows ) {
		if( adminInstance.state.currentFilterField && adminInstance.state.currentFilterField !== "" ) {
			if( rows ) {
				let filtered = [];
				rows.forEach( (candidate) => {
					if( candidate.userlabel.toLowerCase().includes( adminInstance.state.currentFilterField.toLowerCase() ) ) {
						filtered.push( candidate );	
					}
				} );
				return filtered;
			}
			
		}
		return rows;
	}
	
	filterDisplayedUser( rows ) {
		let displayed = [];
		rows.forEach( user => {
			if( user.accessLevel !== UserType.ROOT ) {
				displayed.push( user );
			}
		} );
		return displayed;
	}
	
	renderTab( labelKey ) {
		const key = "administration-tab-nav-item-" + labelKey.replace(/\s/g , "-");
		return ( <Tab key={key}
					  label={I18n.get( labelKey )}
					  className={`admin-button`}
					  disabled={( adminInstance.props.observer.currentUser.type !== UserType.ROOT &&
						  	adminInstance.props.observer.currentUser.type !== UserType.ADMIN &&
						  	adminInstance.props.observer.currentUser.type !== AccountType.RESELLER ) || adminInstance.state.isLoading }/> );
	}
	
	renderTabPanel( labelKey , counterIndex ) {
		const key = "administration-tab-panel-item-" + labelKey.replace(/\s/g , "-");
		const spaceBottom = "mb-3"

		if( counterIndex === 0 ) {
			return ( 
				<TabPanel key={key} value={adminInstance.state.value} index={counterIndex}>
                	<div className="tab-panel-content">
                		<Grid container spacing={1} >
                			<Grid item xs={12} md={12} lg={12}>
                				<Paper className="card-box">
                                    <UserManager payStations={adminInstance.props.payStations}
                								 user={adminInstance.props.observer.currentUser}
                								 API={adminInstance.props.API}
                								 isDarkStyle={adminInstance.props.isDarkStyle}
                								 isDesktop={adminInstance.props.isDesktop}
                								 observer={adminInstance.props.observer}
                								 onGroupDisplay={adminInstance.displayGroupsHandler}
                								 excludeId={adminInstance.props.observer.currentUser.id}
												 accounts={adminInstance.state.accounts}
												 onLoadingComplete={ users => {
													 loadedUsers = users;
													 adminInstance.setState({ isLoading: false } )
												 }}/>
                                </Paper>
                			</Grid>
                		</Grid>
                	</div>
                </TabPanel>
			);
		} else if ( counterIndex === 1 && this.props?.observer?.currentUser?.accountType !== AccountType.CUSTOMER ) {
			return (
				<TabPanel key={key} value={adminInstance.state.value} index={counterIndex}>
					<div className="tab-panel-content">
						<Grid container spacing={1} >
							<Grid item xs={12} md={12} lg={12}>
								<Paper className={ `card-box ${spaceBottom}` }>
									<InstallationManager payStations={adminInstance.props.payStations}
														 user={adminInstance.props.observer.currentUser}
														 API={adminInstance.props.API}
														 isDarkStyle={adminInstance.props.isDarkStyle}
														 isDesktop={adminInstance.props.isDesktop}
														 observer={adminInstance.props.observer}
														 onPaystationRemoved={adminInstance.props.onPaystationRemoved}
														 onRequestedBoxOverview={adminInstance.props.onRequestedBoxOverview}
														 onRequestedBoxDiagnostic={adminInstance.props.onRequestedBoxDiagnostic}/>
								</Paper>
							</Grid>
						</Grid>
					</div>
				</TabPanel>
			);
		} else if ( counterIndex === 2 ) {
			return (
				<TabPanel key={key} value={adminInstance.state.value} index={counterIndex}>
					<div className="tab-panel-content">
						<Grid container spacing={1} >
							<Grid item xs={12} md={12} lg={12}>
								<Paper className={ `card-box ${spaceBottom}` }>
									<AccountManager isDarkStyle={adminInstance.props.isDarkStyle}
													user={adminInstance.props.observer.currentUser}
													API={adminInstance.props.API}
													userDelegate={adminInstance.handleConfirm}/>
								</Paper>
							</Grid>
						</Grid>
					</div>
				</TabPanel>
			);
		} else if ( counterIndex === 3 || ( this.props?.observer?.currentUser?.accountType === AccountType.CUSTOMER && counterIndex === 1 ) ) {
			return (
				<TabPanel key={key} value={adminInstance.state.value} index={counterIndex}>
					<div className="tab-panel-content">
						<Grid container spacing={1} >
							<Grid item xs={12} md={12} lg={12}>
								<Paper className={ `card-box ${spaceBottom}` }>
									<GroupManager isDarkStyle={adminInstance.props.isDarkStyle}
												  user={adminInstance.props.observer.currentUser}
												  API={adminInstance.props.API}
												  payStations={adminInstance.props.payStations}
												  filteredPayStations={adminInstance.props.filteredPayStations}
												  availableUsers={loadedUsers}/>
								</Paper>
							</Grid>
						</Grid>
					</div>
				</TabPanel>
			);
		}
		return null;
	}

	render() {
		if( ! this.state.accounts ) {
			this.loadAccounts();
		}

		let tabs = [];
		tabs.push( this.renderTab( "Manage Users" ) );
		let panels = [];
		panels.push( this.renderTabPanel( "Manage Users" , 0 ) );

		if( this.props?.observer?.currentUser?.accountType !== AccountType.CUSTOMER ) {
			tabs.push( this.renderTab( "Manage Installations" ) );
			tabs.push( this.renderTab( "Manage Accounts" ) );
			panels.push( this.renderTabPanel( "Manage Installations" , 1 ) ) ;
			panels.push( this.renderTabPanel( "Manage Accounts" , 2 ) ) ;
			panels.push( this.renderTabPanel( "Manage Groups" , 3 ) ) ;
		} else {
			panels.push( this.renderTabPanel( "Manage Groups" , 1 ) ) ;
		}
		tabs.push( this.renderTab( "Manage Groups" ) );

		if( this.props.isDesktop ) {
			return (
				<React.Fragment>
					<div className="z-over fullscreen">
						<Tabs 	className="nav-tabs-primary" 
								key="administration-tab-nav"
								value={adminInstance.state.value}
								variant="fullWidth"
								onChange={adminInstance.handleChange}>
							{tabs.map( item => item )}	
						</Tabs>
						{panels.map( item => item )}
						<DialogConfirmRemove handleClose={this.handleConfirm}
											 pendingDelete={this.state.pendingDelete}
											 isDarkStyle={this.props.isDarkStyle}/>
											 
						<DialogUserData handleClose={this.handleConfirm}
										user={this.props.user}
										userRDS={this.props.observer.currentUser}
										pendingEdit={this.state.pendingEdit}
										isDarkStyle={this.props.isDarkStyle}/>

						<DialogDisplayGroups onClear={this.handleClearUserGroups}
											 isDarkStyle={this.props.isDarkStyle}
											 userGroups={this.state.userGroups}/>
					</div>
				</React.Fragment>
			);
		}
		
		return (
			<React.Fragment>
				<div className="z-over fullscreen">
					<Tabs 	className="nav-tabs-primary" 
							key="administration-tab-nav"
							value={adminInstance.state.value}
							variant="scrollable"
							scrollButtons="auto"
							onChange={adminInstance.handleChange}>
						{tabs.map( item => item )}	
					</Tabs>
					{panels.map( item => item )}

					<DialogConfirmRemove handleClose={this.handleConfirm}
										 pendingDelete={this.state.pendingDelete}
										 isDarkStyle={this.props.isDarkStyle}/>
										 
					<DialogUserData handleClose={this.handleConfirm}
									user={this.props.user}
									userRDS={this.props.observer.currentUser}
									pendingEdit={this.state.pendingEdit}
									isDarkStyle={this.props.isDarkStyle}/>

					<DialogDisplayGroups onClear={this.handleClearUserGroups}
										 isDarkStyle={this.props.isDarkStyle}
										 userGroups={this.state.userGroups}/>
				</div>
			</React.Fragment>
		);
	}
}

export default Administration;
